import type en from "../en/auth";
import type { Translation } from "../../types";

const auth: Translation<typeof en> = {
  signIn: {
    subtitle: {
      password: "Connectez-vous à votre espace de travail",
      totp: "Saisissez votre code d’authentification",
      reset: "Nous vous enverrons un lien de réinitialisation par e-mail",
      resetSent: "Consultez votre boîte de réception",
    },
    email: "Adresse e-mail",
    password: "Mot de passe",
    submit: "Se connecter",
    forgotPassword: "Mot de passe oublié ?",
    sendResetLink: "Envoyer le lien",
    backToSignIn: "Retour à la connexion",
    resetSent:
      "Si un compte existe pour <email>{{email}}</email>, un lien de réinitialisation est en route. Il expire dans une heure.",
    totp: {
      appPrompt: "Ouvrez votre application d’authentification",
      backupPrompt: "Saisissez l’un de vos codes de secours",
      codeLabel: "Code à 6 chiffres",
      backupLabel: "Code de secours",
      verify: "Vérifier",
      useBackupCode: "Utiliser un code de secours",
      useApp: "Utiliser votre application d’authentification",
    },
  },
  password: {
    moreNeeded_one: "Encore {{count}} caractère nécessaire.",
    moreNeeded_other: "Encore {{count}} caractères nécessaires.",
  },
  reset: {
    incompleteTitle: "Ce lien est incomplet",
    incompleteBody:
      "Il lui manque la partie qui prouve qu’il vient de nous. Demandez un nouvel e-mail de réinitialisation et suivez le lien qu’il contient sans le modifier.",
    backToSignIn: "Retour à la connexion",
    doneTitle: "Mot de passe modifié",
    doneBody: "Connectez-vous avec votre nouveau mot de passe.",
    goToSignIn: "Aller à la connexion",
    title: "Choisissez un nouveau mot de passe",
    hint: "Au moins 12 caractères. Vos sessions ouvertes restent connectées.",
    newPassword: "Nouveau mot de passe",
    confirm: "Confirmez-le",
    mismatch: "Les deux mots de passe ne correspondent pas.",
    submit: "Modifier le mot de passe",
  },
  verify: {
    working: "Confirmation de votre adresse e-mail…",
    doneTitle: "Adresse e-mail confirmée",
    doneBody: "Merci — c’est tout ce qu’il nous fallait.",
    continue: "Continuer",
    failedTitle: "Ce lien n’a pas fonctionné",
    failedBody:
      "Il a peut-être expiré ou déjà été utilisé. Vous pouvez continuer à utiliser l’application dans tous les cas — la confirmation de votre adresse e-mail n’est pas nécessaire pour vous connecter.",
    goToApp: "Aller à l’application",
  },
  accept: {
    checking: "Vérification de votre invitation…",
    invalidTitle: "Ce lien d’invitation n’est pas valide",
    invalidBody:
      "Il a peut-être été mal saisi, ou révoqué. Demandez à la personne qui vous a invité de vous en envoyer un nouveau.",
    usedTitle: "Cette invitation a déjà été utilisée",
    usedBody: "Si c’était vous, connectez-vous plutôt.",
    goToSignIn: "Aller à la connexion",
    expiredTitle: "Cette invitation a expiré",
    expiredBody:
      "Les invitations sont valables pendant une durée limitée. Demandez-en une nouvelle et elle fonctionnera immédiatement.",
    platformTitle: "Configurez votre espace de travail",
    joinTitle: "Rejoindre {{name}}",
    platformIntro:
      "Vos réunions sont enregistrées, transcrites et consultables. Choisissez un nom pour votre espace de travail — vous pourrez inviter vos collègues une fois connecté.",
    joinIntro: "Vous avez été invité à rejoindre {{name}}. Choisissez un mot de passe pour y accéder.",
    email: "Adresse e-mail",
    name: "Votre nom",
    namePlaceholder: "Camille Martin",
    workspaceName: "Nom de l’espace de travail",
    workspacePlaceholder: "Acme SAS",
    workspaceHint:
      "Généralement le nom de votre entreprise ou de votre équipe. Vous pourrez le modifier plus tard.",
    password: "Mot de passe",
    passwordPlaceholder: "Au moins 12 caractères",
    genericError: "Un problème est survenu. Réessayez.",
    createWorkspace: "Créer mon espace de travail",
    join: "Rejoindre {{name}}",
  },
  errors: {
    invalidCredentials: "Cette adresse e-mail et ce mot de passe ne correspondent pas.",
    invalidPassword: "Ce mot de passe est incorrect.",
    invalidEmail: "Cette adresse e-mail ne semble pas valide.",
    emailNotVerified:
      "Confirmez d’abord votre adresse e-mail — le lien se trouve dans votre boîte de réception.",
    invalidCode: "Ce code est incorrect. Essayez le suivant.",
    invalidBackupCode: "Ce code de secours est incorrect, ou il a déjà été utilisé.",
    tooManyAttempts: "Trop de tentatives. Patientez quelques minutes, puis réessayez.",
    twoFactorExpired:
      "Cette connexion a pris trop de temps. Saisissez à nouveau votre adresse e-mail et votre mot de passe.",
    passwordTooShort: "Les mots de passe doivent comporter au moins 12 caractères.",
    passwordTooLong: "Ce mot de passe est trop long.",
    invalidToken: "Ce lien a expiré. Demandez-en un nouveau.",
    userExists: "Un compte existe déjà avec cette adresse e-mail.",
    rateLimited: "Trop de requêtes. Patientez un instant et réessayez.",
    generic: "Un problème est survenu. Veuillez réessayer.",
  },
};

export default auth;
